import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { Form, Row, Col, Input, FormGroup, Card } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { INTEGRATION_SAMPLE_LEAD_PRODUCT_OPTIONS, MODE, REQUIRED_FEATURE_FLAGS, TOOLTIP_CONSTANTS_FOR_TEST_INTEGRATION, TRUE_AND_FALSE } from 'helpers/sf_constants';
import { testIntegration } from 'store/integration/actions';
import { getOptionFromValueForSelectBox, getPrimaryButtonClass, getPrimaryTextClass, forColumnHeaderWrapper } from 'helpers/sf_utils';
import BootstrapTable from 'react-bootstrap-table-next';
import { dateCreatedFormatter } from 'pages/Admin/Users/UserComponents/UserList/Formatters';
import { useHistory } from 'react-router-dom';
import Select from 'react-select';
import { bsh_isAdminUserDetailsPresent } from 'helpers/sf_browser_storage_helper';
import LabelWithTooltip from 'components/Common/LabelWithTooltip';
import ModifyLoadingIcon from 'components/Common/Loadings/ModifyLoadingIcon';
import { customSortCaret } from 'helpers/bootstrap_table_helper';
import IntegrationTestEditConfigModal from 'pages/integrations/integration-log/IntegrationTestEditConfigModal';
import useNewBrandUI from "hooks/useNewBrandUI";
import { getCampaignOptions } from 'helpers/sf_dashboard_helper';
import ToastAlert, { ToastAlertIconType } from 'components/Common/ToastAlert/ToastAlert';
import useFilteredIntegrationLeadTypes from 'hooks/useFilteredIntegrationLeadTypes';
import useFeatureFlags from 'hooks/useFeatureFlags';

const TestIntegration = ({ mode, initialState, onSubmitState, openNextAccordion, leadIntegrationLogs, activeLeadTypeId }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { campaigns, current_brand } = useSelector((state) => ({
    campaigns: state.Campaign.campaigns,
    current_brand: state.Brands.current_brand,
  }))
  const [optionsCampaign, setOptionsCampaign] = useState([{ options: [] }]);
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const { copyLeadPayloadDropdownOptions } = useFilteredIntegrationLeadTypes();
  const [isFeatureFlagActive] = useFeatureFlags();
  const productSpecificSampleLeadsEnabled = isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_PRODUCT_SPECIFIC_SAMPLE_LEADS);
  const [selectedLeadType, setSelectedLeadType] = useState(getOptionFromValueForSelectBox(copyLeadPayloadDropdownOptions, parseInt(initialState?.lead_integration?.ui_lead_type_id)) || null)
  const [selectedProductType, setSelectedProductType] = useState(INTEGRATION_SAMPLE_LEAD_PRODUCT_OPTIONS[0]);

  const isTemplateIntegration = !!initialState?.lead_integration?.is_template;

  const onClickSubmitLeadIntegration = (e) => {
    e.preventDefault()
    openNextAccordion();
    if (!isTemplateIntegration) {
      onSubmitState(initialState)
    }
    if (bsh_isAdminUserDetailsPresent()) {
      return;
    }
    history.push("/integrations")
  }

  const { test_integration_loading, integration_sample_leads } = useSelector((state) => ({
    test_integration_loading: state.Integration.test_integration_loading,
    integration_sample_leads: state.Integration.integration_sample_leads
  }))
  const [sampleLeadConfig, setSampleLeadConfig] = useState()

  useEffect(() => {
    setSampleLeadConfig(integration_sample_leads)
  }, [integration_sample_leads])

  const findSelectedSampleLead = () => {
    const sampleLeads = sampleLeadConfig || []
    const matchedSampleLead = productSpecificSampleLeadsEnabled
      ? sampleLeads.find(el => el.lead_type_id === selectedLeadType?.value && el.product_type_id === selectedProductType?.value)
      : null

    return matchedSampleLead || sampleLeads.find(el => el.lead_type_id === selectedLeadType?.value)
  }

  // test integration
  const onClickTestIntegration = () => {
    if (!selectedLeadType) {
      return;
    }
    const lead_integration_id = initialState?.lead_integration?.id
    const sample_lead = findSelectedSampleLead()
    const lead_integration = {
      ui_lead_type_id: selectedLeadType?.value
    }

    if (!initialState?.lead_integration?.res_success_regex) {
      ToastAlert.fire({
        icon: ToastAlertIconType.WARNING,
        text: 'Please update the Integration Success Response Type before proceeding.'
      })
      return;
    }
    if (lead_integration_id) {
      dispatch(testIntegration({
        id: lead_integration_id,
        lead_type_id: selectedLeadType?.value || null,
        product_type_id: productSpecificSampleLeadsEnabled ? selectedProductType?.value : undefined,
        campaign_id: selectedCampaign?.value,
        lead_json: (sample_lead?.data)
      }))
      onSubmitState({ lead_integration })
    }
  }
  const onClickSubmitModal = (object, lead_type_id, product_type_id) => {
    setSampleLeadConfig((prev) => {
      return (prev || []).map((lead) => {
        const isSelectedSampleLead = productSpecificSampleLeadsEnabled
          ? lead.lead_type_id === lead_type_id && lead.product_type_id === product_type_id
          : lead.lead_type_id === lead_type_id

        if (isSelectedSampleLead) {
          return {
            ...lead,
            data: object
          };
        }
        return lead;
      });
    });
  };

  const columns = [
    {
      dataField: TOOLTIP_CONSTANTS_FOR_TEST_INTEGRATION.ID_FIELD.DATA_FIELD,
      text: TOOLTIP_CONSTANTS_FOR_TEST_INTEGRATION.ID_FIELD.NAME,
      sort: true,
      hasInfoTooltip: true,
      tooltipDescription: TOOLTIP_CONSTANTS_FOR_TEST_INTEGRATION.ID_FIELD.TOOLTIP_MESSAGE,
      headerFormatter: forColumnHeaderWrapper,
    },
    {
      dataField: "created_at",
      text: "Sent at",
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
      formatter: (cell, _) => dateCreatedFormatter(cell, null),
    },
    {
      dataField: TOOLTIP_CONSTANTS_FOR_TEST_INTEGRATION.POSTING_URL.DATA_FIELD,
      text: TOOLTIP_CONSTANTS_FOR_TEST_INTEGRATION.POSTING_URL.NAME,
      sort: true,
      hasInfoTooltip: true,
      tooltipDescription: TOOLTIP_CONSTANTS_FOR_TEST_INTEGRATION.POSTING_URL.TOOLTIP_MESSAGE,
      headerFormatter: forColumnHeaderWrapper,
    },
    {
      dataField: TOOLTIP_CONSTANTS_FOR_TEST_INTEGRATION.CONNECTION_TYPE.DATA_FIELD,
      text: TOOLTIP_CONSTANTS_FOR_TEST_INTEGRATION.CONNECTION_TYPE.NAME,
      sort: true,
      hasInfoTooltip: true,
      tooltipDescription: TOOLTIP_CONSTANTS_FOR_TEST_INTEGRATION.CONNECTION_TYPE.TOOLTIP_MESSAGE,
      headerFormatter: forColumnHeaderWrapper,
    },
    {
      dataField: TOOLTIP_CONSTANTS_FOR_TEST_INTEGRATION.STATUS.DATA_FIELD,
      text: TOOLTIP_CONSTANTS_FOR_TEST_INTEGRATION.STATUS.NAME,
      sort: true,
      hasInfoTooltip: true,
      tooltipDescription: TOOLTIP_CONSTANTS_FOR_TEST_INTEGRATION.STATUS.TOOLTIP_MESSAGE,
      headerFormatter: forColumnHeaderWrapper,
    },
    {
      dataField: TOOLTIP_CONSTANTS_FOR_TEST_INTEGRATION.STATUS_CODE.DATA_FIELD,
      text: TOOLTIP_CONSTANTS_FOR_TEST_INTEGRATION.STATUS_CODE.NAME,
      sort: true,
      hasInfoTooltip: true,
      tooltipDescription: TOOLTIP_CONSTANTS_FOR_TEST_INTEGRATION.STATUS_CODE.TOOLTIP_MESSAGE,
      headerFormatter: forColumnHeaderWrapper,
      formatter: (cell, _) => {
        return (
          <span>
            <i className={`mdi mdi-circle font-size-12 ${cell ? 'sfgreen' : 'sfred'}`} />
            <span className="ms-2">{cell ? 'Successful' : 'Failed'}</span>
          </span>
        )
      }
    },
    {
      dataField: TOOLTIP_CONSTANTS_FOR_TEST_INTEGRATION.RESPONSE.DATA_FIELD,
      text: TOOLTIP_CONSTANTS_FOR_TEST_INTEGRATION.RESPONSE.NAME,
      sort: true,
      hasInfoTooltip: true,
      tooltipDescription: TOOLTIP_CONSTANTS_FOR_TEST_INTEGRATION.RESPONSE.TOOLTIP_MESSAGE,
      headerFormatter: forColumnHeaderWrapper,
      style: { maxWidth: '100px' },
      formatter: (cell, _) => {
        return (
          <div className="text-truncate text-black">
            <code className={`${getPrimaryTextClass()}`}>
              {cell}
            </code>
          </div>
        )
      }
    }
  ]

  const defaultSorted = [{
    dataField: 'id',
    order: 'desc',
  }];

  const expandRow = {
    renderer: r => {
      return (
        <Card>
          <span className='ms-2 fw-bold text-black mb-1 mt-2 h6'>Test Response :</span>
          <code style={{
            whiteSpace: "pre-wrap",  // To preserve line breaks and spaces
            padding: "10px",  // Add some padding for better readability
            borderRadius: "5px",  // Round the corners a bit
            backgroundColor: "#000000",
            color: "#fff",
          }}>
            {r.res_body}
          </code>
        </Card>
      )
    }
  }

  const [testEditConfigModal, setTestEditConfigModal] = useState({ active: null });

  const onClickOpenEditTestConfig = () => {
    if (!selectedLeadType) {
      return;
    }
    const sample_lead = findSelectedSampleLead()
    setTestEditConfigModal({ active: true, payload: sample_lead });
  }

  const show_rtb_brand_ui_changes = useNewBrandUI()

  useEffect(() => {
    if (!campaigns || !current_brand || !selectedLeadType) {
      return;
    }
    const filteredCampaigns = show_rtb_brand_ui_changes ? campaigns : campaigns.filter(campaign => campaign.brand_id.toString() === current_brand.id.toString());
    const campaignOpts = filteredCampaigns?.filter((el) => (
      (el?.lead_type_id) === (selectedLeadType?.value) &&
      (!productSpecificSampleLeadsEnabled || el?.product_type_id === selectedProductType?.value)
    ))
    const finalCampaignOptions = getCampaignOptions(campaignOpts, show_rtb_brand_ui_changes, false)
    setOptionsCampaign(finalCampaignOptions);

  }, [campaigns, current_brand, selectedLeadType, selectedProductType?.value, productSpecificSampleLeadsEnabled, show_rtb_brand_ui_changes]);


  return (
    <React.Fragment>
      <IntegrationTestEditConfigModal
        show={testEditConfigModal}
        setTestEditConfigModal={setTestEditConfigModal}
        onClickCloseModal={() => setTestEditConfigModal(TRUE_AND_FALSE.FALSE)}
        onClickSubmitModal={onClickSubmitModal}
      />
      <Form>
        <Row className='d-flex align-items-end'>
          <Col md={12} xl={12}>
            <Row className="mb-3">
              {productSpecificSampleLeadsEnabled && (
                <Col md={2}>
                  <LabelWithTooltip is_active={false} name="Product" target="integration_test_product" htmlFor="integration_test_product" />
                  <Select
                    options={INTEGRATION_SAMPLE_LEAD_PRODUCT_OPTIONS}
                    classNamePrefix="select2-selection"
                    onChange={option => {
                      setSelectedProductType(option)
                      setSelectedCampaign(null)
                    }}
                    value={selectedProductType}
                  />
                </Col>
              )}
              <Col md={3}>
                <LabelWithTooltip name={TOOLTIP_CONSTANTS_FOR_TEST_INTEGRATION.LEAD_TYPE.NAME} tooltip_message={TOOLTIP_CONSTANTS_FOR_TEST_INTEGRATION.LEAD_TYPE.TOOLTIP_MESSAGE} target={TOOLTIP_CONSTANTS_FOR_TEST_INTEGRATION.LEAD_TYPE.ID} htmlFor="name" />
                <Select
                  options={copyLeadPayloadDropdownOptions}
                  classNamePrefix="select2-selection"
                  onChange={option => {
                    setSelectedLeadType(option)
                    setSelectedCampaign(null)
                  }}
                  value={selectedLeadType}
                />
              </Col>
              <Col md={3}>
                <LabelWithTooltip
                  is_active={false}
                  name={TOOLTIP_CONSTANTS_FOR_TEST_INTEGRATION.CAMPAIGNS.NAME}
                  tooltip_message={TOOLTIP_CONSTANTS_FOR_TEST_INTEGRATION.CAMPAIGNS.TOOLTIP_MESSAGE}
                  target={TOOLTIP_CONSTANTS_FOR_TEST_INTEGRATION.CAMPAIGNS.ID}
                  htmlFor={TOOLTIP_CONSTANTS_FOR_TEST_INTEGRATION.CAMPAIGNS.ID}
                />
                <Select
                  options={optionsCampaign}
                  classNamePrefix="select2-selection"
                  onChange={option => {
                    setSelectedCampaign(option)
                  }}
                  value={selectedCampaign}
                />
              </Col>
              <Col md={2} className="align-self-end">
                <button className="btn btn-sfblue flex-item font-size-13" style={{ width: "fit-content" }} type="button" name="test" onClick={onClickOpenEditTestConfig}
                  disabled={!selectedLeadType}
                >
                  Edit Sample Lead
                </button>
              </Col>
            </Row>
          </Col>
          <Col md={4}>
            <FormGroup>
              <LabelWithTooltip name={TOOLTIP_CONSTANTS_FOR_TEST_INTEGRATION.NAME_FIELD.NAME} tooltip_message={TOOLTIP_CONSTANTS_FOR_TEST_INTEGRATION.NAME_FIELD.TOOLTIP_MESSAGE} target={TOOLTIP_CONSTANTS_FOR_TEST_INTEGRATION.NAME_FIELD.ID} htmlFor="name" />
              <Input type="text" disabled={true} name="default_value" value={initialState?.lead_integration?.name} />
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup>
              <LabelWithTooltip name={TOOLTIP_CONSTANTS_FOR_TEST_INTEGRATION.POSTING_URL.NAME} tooltip_message={TOOLTIP_CONSTANTS_FOR_TEST_INTEGRATION.POSTING_URL.TOOLTIP_MESSAGE} target={TOOLTIP_CONSTANTS_FOR_TEST_INTEGRATION.POSTING_URL.ID} htmlFor="name" />
              <Input type="text" disabled={true} name="default_value" value={initialState?.lead_integration?.posting_url} />
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup>
              <div className="d-flex align-items-center">
                <button className="btn btn-sfblue flex-item font-size-13" style={{ width: "fit-content" }} type="button" name="test" onClick={onClickTestIntegration} disabled={!selectedLeadType}> {test_integration_loading ? (<span className='d-flex font-size-13'><ModifyLoadingIcon color="light" /> <span className="ms-2">Testing...</span></span>) : "Test Connection"}</button>
                <button className={`btn ${getPrimaryButtonClass()} flex-item ms-3`} disabled={test_integration_loading || !leadIntegrationLogs?.length} type="submit" name="submit" onClick={onClickSubmitLeadIntegration}> {false ? "Saving" : (mode === MODE.EDIT ? "Save" : "Create")}</button>
              </div>
            </FormGroup>
          </Col>
        </Row>
        <Row className="sfTable-Container table-responsive">
          {!!leadIntegrationLogs?.length &&
            <Col xl="12">
              <BootstrapTable
                keyField="id"
                columns={columns}
                data={[_.orderBy(leadIntegrationLogs, ['id'], ['desc'])[0]]}
                responsive
                expandRow={expandRow}
                bordered={false}
                striped={false}
                defaultSorted={defaultSorted}
                rowClasses="tr-hover"
                headerClasses="sftableHeader text-black thead-50"
                classes="table align-middle table-nowrap text-black"
                headerWrapperClasses="thead-light"
                noDataIndication="You currently don't have any Test Logs"
                sort={{ sortCaret: customSortCaret }}
              />
            </Col>}
        </Row>
      </Form>
    </React.Fragment>
  )
}

export default TestIntegration
